module.exports = __webpack_public_path__ + "static/20-cf2a78535929aad91e57124d7b350902.png";